export default __webpack_public_path__ + "static/1153-aa53a78ceca7d27f2f5a76bc30df7dcd.gif";